import { css, cssManager } from '@design.estate/dees-element';
import { themeDefaultStyles } from '../../00theme.js';

export const thumbnailBaseStyles = [
  themeDefaultStyles,
  cssManager.defaultStyles,
  css`
    :host {
      display: inline-block;
      position: relative;
    }

    .tile-container {
      position: relative;
      width: 200px;
      height: 260px;
      background: var(--dees-color-bg-secondary);
      border-radius: 4px;
      overflow: hidden;
      transition: box-shadow 0.2s ease;
      box-shadow: var(--dees-shadow-sm);

    }

    .tile-container.clickable {
      cursor: pointer;
    }

    .tile-container.clickable:hover {
      box-shadow: var(--dees-shadow-lg);
    }

    .tile-container.clickable:hover .tile-overlay {
      opacity: 1;
    }

    .tile-content {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      overflow: hidden;
    }

    .tile-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.75);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 8px;
      opacity: 0;
      transition: opacity 0.2s ease;
      z-index: 20;
    }

    .tile-overlay dees-icon {
      font-size: 24px;
      color: white;
    }

    .tile-overlay span {
      font-size: 14px;
      font-weight: 500;
      color: white;
    }

    .tile-info-bar {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 4px 8px;
      background: color-mix(in srgb, var(--dees-color-bg-primary) 95%, transparent);
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 10px;
      font-weight: 500;
      color: var(--dees-color-text-secondary);
      backdrop-filter: blur(12px);
      z-index: 25;
      font-variant-numeric: tabular-nums;
    }

    .info-label {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      min-width: 0;
    }

    .info-spacer {
      flex: 1;
    }

    .info-detail {
      white-space: nowrap;
      opacity: 0.7;
      flex-shrink: 0;
    }

    .tile-loading,
    .tile-error {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 12px;
      color: var(--dees-color-text-secondary);
    }

    .tile-loading {
      background: var(--dees-color-bg-secondary);
    }

    .tile-error {
      background: var(--dees-color-badge-error-bg);
      color: var(--dees-color-badge-error-fg);
    }

    .tile-error dees-icon {
      font-size: 32px;
    }

    .tile-spinner {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      border: 2px solid var(--dees-color-border-strong);
      border-top-color: var(--dees-color-link);
      animation: spin 0.8s linear infinite;
    }

    .tile-loading-text,
    .tile-error-text {
      font-size: 13px;
      font-weight: 500;
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }

    /* Size variants */
    :host([size="small"]) .tile-container {
      width: 150px;
      height: 195px;
    }

    :host([size="large"]) .tile-container {
      width: 250px;
      height: 325px;
    }

    /* Grid optimizations */
    :host([grid-mode]) .tile-container {
      will-change: auto;
    }
  `,
];
